import { useEffect, useState } from "react";
import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import Tabela from "../../Componentes/Utils/Tabela";
import { useModal } from "../../contexts/ModalContext";
import axios from "axios";
import styled from "styled-components";
import ModalValoresExames from "./ModalValoresExames";

import { GoPlus } from "react-icons/go";
import ModalNewClinica from "./ModalNewClinica";

const LinhaTabela = styled.tr`
    color: #000;
`
const StatusIcon = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${ props => props.status ? "green" : "red" };
    margin: auto;
`
const ContainerBtnAdd = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    margin-bottom: 10px;
`
const BotaoAdicionar = styled.button`
    width: 170px;
    height: 100%;
    background-color: #0264FF;
    color: white;
    border: none;
    border-radius: 10px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background-color: #0250cc;
    }

    svg {
        font-size: 18px;
    }
`;

const ClinicasModal = () => {

    const { openModal, closeModal, isModalOpen } = useModal();

    const [ clinicas, setClinicas ] = useState([]);

    const [ selectedClinica, setSelectedClinica ] = useState( null );

    const fetchClinicas = async () => {

        try{

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/ASO/GetClinicas/')
            setClinicas( data )

        }catch( e ){

            console.log( e )

        }

    }

    useEffect(() => {

        fetchClinicas();

    }, [])

    const openValores = ( valor ) => {

        setSelectedClinica( valor );
        openModal('modalValoresExames')

    }

    const closeValores = () => {

        setSelectedClinica( null )
        closeModal();

    }

    const openModalNewClinica = () => {

        openModal('modalNewClinica');

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="xl" header={ true } close={ closeModal } >
                    <ContainerBtnAdd>
                        <BotaoAdicionar onClick={ openModalNewClinica } >
                            <GoPlus />
                            Nova Clínica
                        </BotaoAdicionar>
                    </ContainerBtnAdd>
                    <Tabela>
                        <thead>
                            <tr>
                                <th colSpan={2} >CLÍNICAS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                clinicas.map(( obj ) => (
                                    <LinhaTabela key={ obj.id } onClick={ () => openValores( obj.identifier ) } >
                                        <td>{ obj.clinica }</td>
                                        <td>
                                            <StatusIcon status={ obj.ativo } />
                                        </td>
                                    </LinhaTabela>
                                ))
                            }
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {
                isModalOpen('modalValoresExames') && (
                    <ModalValoresExames
                        clinica={ selectedClinica }
                        fecharModal={ closeValores }
                    />
                )
            }
            {
                isModalOpen('modalNewClinica') && (
                    <ModalNewClinica
                        
                    />
                )
            }
        </>
    )
}

export default ClinicasModal;